// 
import {
  startsWith,
  toCamelCase,
  toSelectorCase,
} from './string';

const RBRACE = /^(?:\{.*\}|\[.*\])$/;
const NUMBER_REG = /^\d*\.?\d*$/;
const PREFIX = 'data-';

export const parseDataset = (dataset) => {
  let data = dataset;
  const parser = JSON.parse;

  if (typeof data === 'string') {
    try {
      if (data === 'true') {
        data = true;
      } else if (data === 'false') {
        data = false;
      } else if (data === 'null') {
        data = null;
      } else if (data === 'undefined') {
        data = undefined;
      } else if (NUMBER_REG.test(data)) {
        data = parseFloat(data);
      } else if (RBRACE.test(data)) {
        data = parser(data);
      }
    } catch (e) {
      data = undefined;
    }
  } else {
    data = undefined;
  }
  return data;
};

const getAllDatasetsAndParse = (element) => {
  const dataSet = {};
  const { attributes } = element;
  for (let i = 0; i < attributes.length; i += 1) {
    const attribute = attributes[i];
    if (startsWith(attribute.name, PREFIX)) {
      // We use substr(5), since it's faster than replacing 'data-' with ''.
      const key = toCamelCase(attribute.name.substr(5));
      dataSet[key] = parseDataset(attribute.value);
    }
  }
  // odstaneni vsech klicu, ktere maji hodnotu undefined.
  // http://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
  return JSON.parse(JSON.stringify(dataSet));
};

// Naparsuje všechny nebo volitelný dataset na elementu do základných JS datových typů
export const getDataSet = (
  element,
  optDataSet,
) => {
  if (optDataSet) {
    return parseDataset(element.getAttribute(PREFIX + toSelectorCase(optDataSet)));
  }
  return getAllDatasetsAndParse(element);
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/dataset.js